import { API_ROUTE_ADMIN_INVOICE } from '@/resources/api-routes'
import { get } from '@/util/auth'

import type { InvoiceOriginal } from './types'

const IS_NEW_BACKEND_API = true

export const getInvoiceDetails = async (id: number) =>
  (
    await get<{ invoice: InvoiceOriginal }>(
      API_ROUTE_ADMIN_INVOICE.replace(':invoiceId', String(id)),
      IS_NEW_BACKEND_API
    )
  ).invoice
